module.exports = __webpack_public_path__ + "media/music/d72b98474fc83d6268886779339e242e.mp3";